<template>
  <!-- if it's editable, don't show it on a new submit mode -->
  <div
    v-if="!isEditable ? !isNew : true"
    :class="isSubmitting || isUploading ? 'form unclickable' : 'form'"
  >
    <div class="form-header">
      <div>{{ title }}</div>
      <div v-if="isUploading" class="loader"></div>
    </div>
    <div v-for="(detail, idx) in model" :key="idx">
      <div v-if="detail.type === 'object'">
        <div v-for="(kvs, idx) in detail.value" :key="idx">
          <div v-for="(val, k) in kvs" :key="k" class="form-group">
            <div class="form-label">{{ detail.template[k].title }}</div>
            <div v-if="!isNew && !isUpdating" class="form-input-group">
              {{ kvs[k] }}
            </div>
            <div v-if="isUpdating || isNew" class="form-input-group">
              <input class="form-control" type="input" v-model="kvs[k]" />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="detail.type === 'file' && !isNew"
        style="display:flex;flex-flow:column;align-items:center;"
      >
        <div>
          <i
            v-if="!detail.value"
            class="fas fa-user-circle"
            style="font-size:100px;color:#39a2d9"
          ></i>
          <img
            v-if="detail.value"
            class="upload-img"
            :src="`${detail.value}?${new Date().getTime()}`"
            alt="Avatar"
          />
        </div>
        <div style="padding:10px;">
          <label :for="detail.name" class="uploader">
            <i class="fas fa-camera"></i>
            Change Profile Picture
          </label>
          <input
            :id="detail.name"
            style="display:none;"
            type="file"
            accept="image/*"
            @change="uploadFile($event.target.files[0], detail)"
          />
        </div>
      </div>
      <div v-if="detail.title" class="form-group">
        <div class="form-label">
          {{ detail.title }}
          <span style="color:#c0392b" v-if="isEditable && detail.required"
            >*</span
          >
        </div>
        <div v-if="!isNew && !isUpdating" class="form-input-group">
          {{ valueLabel(detail) }}
        </div>
        <div v-if="isUpdating || isNew" class="form-input-group">
          <input
            v-if="detail.type == 'input'"
            class="form-control"
            :type="detail.inputType || 'input'"
            v-model="detail.value"
          />
          <input
            v-if="detail.type == 'array'"
            class="form-control"
            type="input"
            v-model="detail.value[0]"
          />
          <Datepicker
            class="form-control"
            v-if="detail.type === 'datepicker'"
            :model.sync="detail.value"
          />
          <select
            v-if="detail.type == 'select-enum'"
            class="form-control"
            v-model="detail.value"
          >
            <option selected="true" disabled="disabled">Choose</option>
            <option
              v-for="option in detail.options"
              :key="option.id"
              :value="option.id"
              >{{ option.name }}</option
            >
          </select>
          <select
            v-if="detail.type == 'select'"
            class="form-control"
            v-model="detail.value"
          >
            <option selected="true" disabled="disabled">Choose</option>
            <option
              v-for="(option, optionIdx) in detail.options"
              :key="optionIdx"
              >{{ option }}</option
            >
          </select>
        </div>
      </div>
    </div>
    <div
      v-if="!isNew && isEditable"
      style="display:flex;justify-content:center;padding:25px;"
    >
      <button
        v-if="!isUpdating"
        class="button-square green"
        style="font-size:18px;"
        @click="$emit('update:isUpdating', true)"
      >
        <i style="margin-bottom:5px;" class="fas fa-edit"></i>
        <div style="margin-right:5px;">Edit</div>
      </button>
      <button
        v-if="isUpdating"
        class="button-square"
        style="margin-right:10px;"
        @click="$emit('update:isSubmitting', true)"
      >
        Save
      </button>
      <button
        v-if="isUpdating"
        class="button-square red"
        @click="$emit('update:isUpdating', false)"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { http } from '../../digilib_web/core/digitify';
import Datepicker from './input_date';

export default {
  props: {
    id: Number,
    endpoint: String,
    title: String,
    isUpdating: Boolean,
    isSubmitting: Boolean,
    isEditable: {
      type: Boolean,
      default: true
    },
    model: Array
  },
  computed: {
    isNew() {
      return this.id < 0;
    }
  },
  components: {
    Datepicker
  },
  data() {
    return {
      isUploading: false
    };
  },
  methods: {
    valueLabel: function(detail) {
      if (detail.type === 'select-enum') {
        let found = detail.options.find(x => x.id === detail.value);
        return found ? found.name : '-';
      } else if (detail.type === 'datepicker') {
        if (detail.value) {
          return dayjs(detail.value).format('DD-MM-YYYY');
        }
      } else if (detail.type === 'array') {
        // for now just use the first index of the array
        return !detail.value || detail.value.length === 0
          ? '-'
          : detail.value[0];
      } else if (detail.currency === 'rupiah' && detail.value) {
        return `Rp. ${detail.value.toLocaleString()}`;
      }
      return detail.value || '-';
    },
    uploadFile: function(file, formItem) {
      if (file) {
        // limit the file size to 2 mb for now
        if (file.size > 2000000) {
          alert(`File size can't be more than 2 mb`);
          return;
        }
        this.isUploading = true;
        let formData = new FormData();
        formData.append('file', file);
        http
          .post(`${this.endpoint}/${this.id}${formItem.endpoint}`, formData)
          .then(json => {
            this.isUploading = false;
            if (json.success) {
              formItem.value = json.data.url;
            }
          });
      }
    }
  }
};
</script>

<style scoped>
.form {
  flex: 1 1 auto;
  font-size: 0.9em;
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
}
.form-header,
.form-group {
  display: -webkit-flex;
  display: flex;
  padding: 8px;
}
.form-header {
  background-color: #f7f8f7;
  margin-bottom: 1rem;
  padding-top: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.1;
  color: #001b3d;
  text-transform: uppercase;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
}
.form-group {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.form-label {
  -webkit-flex: 1;
  flex: 1;
  text-transform: uppercase;
}
.form-input-group {
  -webkit-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row;
  flex-flow: row;
}
.form-control {
  padding: 0.5em;
  border: 1px solid #cecece;
  font-size: 0.9rem;
  line-height: 1.25;
  color: #464a4c;
  height: 32px;
  border-radius: 0.2rem;
  background-color: #fff;
  -webkit-flex: 1 1 auto;
  flex: 1 1 auto;
}
.uploader {
  padding: 5px;
  color: #39a2d9;
  cursor: pointer;
  text-transform: uppercase;
}
.upload-img {
  height: 100px;
  width: 100px;
  border-radius: 50%;
}
@media all and (max-width: 640px) {
  .form-group {
    -webkit-flex-flow: column;
    flex-flow: column;
    align-items: inherit;
  }
  .form-control {
    height: 36px;
  }
}
</style>
